<!-- 销售结算记账 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <salesSettleKeepAction v-if="showStatus" ref="salesSettleKeepAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></salesSettleKeepAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" show-summary :summary-method="getSummaries" v-if="pageShowData.jurTableVo" :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row>
                <el-table-column label="选择操作" align="center" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column v-if="tableValye.isShow == 1" align="center" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                    :prop="tableValye.entityField" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.entityField == 'psomState'">
                            {{ $store.state.purchaseOrderState[scope.row[tableValye.entityField]].name }}
                        </span>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'psomIswmsm'">
                            {{ scope.row.psomIswmsm == 0 ? '否' : '是' }}
                        </el-tag>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'settleMode'">
                            {{ scope.row.settleMode == 0 ? '按单据' : '按明细' }}
                        </el-tag>
                        <span v-else-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{
                        scope.row[tableValye.entityField] }}</a>
                        </span>
                        <span v-else-if="tableValye.entityField == 'createTime'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <div v-else-if="tableValye.fieldType == 'imgUrl'||tableValye.fieldType == 'imgType'">
                            <span v-if="scope.row[tableValye.entityField]">
                                <span v-for="(item, index) in scope.row[tableValye.entityField].split(',')" :key="index" class="img_box">
                                    <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="resolveImgSrc(item)" :preview-src-list="scope.row[tableValye.entityField].split(',').map(val => resolveImgSrc(val))">
                                    </cusImage>
                                </span>
                            </span>
                        </div>
                        <span v-else-if="tableValye.fieldType == 'formatter'">
                            <span v-for="item in JSON.parse(tableValye.formatterContent)">
                                <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">
                                    {{ item.value }}
                                </el-tag>
                            </span>
                        </span>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog title="修改备注" v-if="remarkVisible" :visible.sync="remarkVisible" width="600px">
            <el-form @submit.native.prevent size="mini" :show-message="false" label-width="120px" :model="remarkData" ref="remarkData">
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model.trim="remarkData.remark" type="textarea" rows="3" :maxlength="$store.state.inputLength" placeholder="请输入备注"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="remarkVisible = false">取消</el-button>
                <el-button type="primary" @click="sendDataAction('remarkData')">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="actionType == 6 ? '上传凭证' : '查看'" :visible.sync="dialogVisible1" width="200px">
            <div v-if="actionType == 6" class="upload_box">
                <input style="display: none;" type="file" id="proofImgUpload" multiple="1" name="proofImgUpload" @change="(e) => { fileUpload(e.target.files, e) }" />
                <ul v-if="proofImg" class="upload">
                    <li>
                        <i class="el-icon-error del" @click="delRemove()"></i>
                        <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${proofImg}`" :preview-src-list="[`${imgUrl}/${proofImg}`]">
                        </cusImage>
                    </li>
                    <!-- <li>
                        <label for="proofImgUpload" class="image_label">
                            <i class="el-icon-plus icon"></i>
                        </label>
                    </li> -->
                </ul>
                <ul v-else class="upload">
                    <li>
                        <label for="proofImgUpload" class="image_label">
                            <i class="el-icon-plus icon"></i>
                        </label>
                    </li>
                </ul>
            </div>
            <ul v-else-if="actionType == 7" class="upload">
                <li>
                    <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${proofImg}`" :preview-src-list="[`${imgUrl}/${proofImg}`]">
                    </cusImage>
                </li>
            </ul>
            <span slot="footer" class="dialog-footer" v-if="actionType == 6">
                <el-button @click="dialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="scpzClick">提交</el-button>
            </span>
        </el-dialog>
        <el-dialog title="查询结算明细" v-if="detailsShow" :visible.sync="detailsShow" width="70%">
            <el-table size="mini" stripe :data="detailsData" height="400" border style="width: 100%" highlight-current-row>
                <el-table-column min-width="150" prop="businessId" label="单据号" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="130" prop="bgmName" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="150" prop="spec" label="规格" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="150" prop="manufacturer" label="生产厂商" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="120" prop="placeorigin" label="产地" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" prop="psprice" label="含税价格" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" prop="psmoney" label="含税金额" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" prop="settlementMoney" label="已结算金额" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" prop="settleMoney" label="付款金额" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" prop="settleCount" label="结算数量" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" prop="bgpUnitmeasurement" label="包装单位" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="100" prop="packingSpec" label="装箱规格" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="120" prop="accountTime" label="出库日期" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.accountTime">
                            {{ $common.getLocalTime(scope.row.accountTime) }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../../byComponents/ExtractionScheme.vue";
import salesSettleKeepAction from '@/components/salesSettleKeepAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
        salesSettleKeepAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            seId: "",
            seWidth: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: '',
            smId: '',
            showStatus: false,
            actionData: {},
            parentSearchData: {},
            requesUrl: "",
            imgUrl: "",
            ormId: "",
            remarkVisible: false,
            remarkData: {
                remark: "",
            },
            dialogVisible1: false,
            importType: "suSettleAccountuploadImg",
            url: "suSettleAccount/uploadImg",
            proofImg: "",
            actionType: 6,
            //-------------------------
            detailsShow: false,
            detailsData: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.smName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.smId = ''
                }
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        resolveImgSrc(item) {
            if (!item) return '';
            if (/^https?:\/\//i.test(item)) {
                return item;
            }
            return `${this.imgUrl}/${item}`;
        },
        async scpzClick() {
            if (!this.proofImg) {
                this.$message.error('请上传凭证')
                return
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            const res = await this.$http.suSettleAccountuploadImg({
                ids: [dataInfo.psacmId],
                proofImg: this.proofImg
            })
            if (res.status == 200) {
                this.$message.success(res.message)
                this.getDataList()
                this.proofImg = ""
                this.dialogVisible1 = false
            }
        },
        delRemove() {
            this.proofImg = ""
        },
        async fileUpload(files, e) {
            const params = {
                file: files[0]
            }
            const response = await this.$http.uploadimgUploadPath(params, true)
            console.log(response, "测试");

            if (response.status == 200) {
                this.proofImg = response.result
            } else {
                e.target.value = ""
                this.$message.error(response.message)
            }
        },
        getSummaries(param) {
            let { columns, data } = param;
            console.log(columns, "测试");

            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                var arr = this.pageShowData.jurTableVo.jurconfigtable.filter(item => item.fieldType == "number")
                if (arr.length > 0) {
                    if (column.property == arr[0].entityField) {
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            let num = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0);
                            sums[index] = this.$common.getDecimalInfo(3, num);
                        } else {
                            sums[index] = '';
                        }
                    }
                } else {
                    sums[index] = ''
                }

            });
            return sums;
        },
        // 子组件触发
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)

            }
            // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
        },
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },

        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },

        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true
            this.seId = sId
            this.seType = type
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        isShowData(name, value) {
            switch (name) {
                case 'supplier':
                    var dataInfo = sessionStorage.getItem('selectSupplierData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.psomBuycus = dataInfo.smId
                        this.getRequestData.smName = dataInfo.smName
                    }
                    break;
            }
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList()
                this.getButtonList()
                this.formDataList = this.pageShowData.jurFormVoList
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType)
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    break;
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.remarkData.id = dataInfo.psacmId
                    this.remarkData.remark = dataInfo.psacmRemark
                    this.remarkVisible = true
                    break;
                case 2:
                    this.delDataAction()
                    break;
                case 3:
                    this.submitDataAction()
                    break;
                case 4:
                    this.exportData()
                    break;
                case 6:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.actionType = 6
                    this.proofImg = ""
                    this.dialogVisible1 = true
                    break;
                case 7:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    this.actionType = 7
                    this.proofImg = dataInfo.proofImg ? dataInfo.proofImg : ""
                    this.dialogVisible1 = true
                    break;
                case 9:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    window.location.href = this.requesUrl + '/suSettleAccount/exportSettleDetail?psacmId=' + dataInfo.psacmId
                    break;
                case 8:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.detailsShow = true
                    this.queryDetails()
                    break;
                case 10:
                    this.hongChong();
                    break;

            }
        },
        async queryDetails() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            var responseData = await this.$http.suSettleAccountquerySettleDetail({ ids: [dataInfo.psacmId] });
            if (responseData.status == 200) {
                this.detailsData = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }

        },
        async sendDataAction(formName) {
            var responseData = await this.$http.suSettleAccountRemark(this.remarkData);
            if (responseData.status == 200) {
                this.getDataList()
                this.remarkVisible = false
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //  导出
        exportData() {
            this.getRequestData.cmId = this.getRequestData.cmId ? this.getRequestData.cmId : "";
            window.location.href = this.requesUrl + '/suSettleApply/exportSuSettleData?ormId=' + String(this.ormId) + '&cmId=' + this.getRequestData.cmId + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end;
        },
        // 红冲
        hongChong() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            this.$confirm("确定红冲吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var data = {
                        ids: [dataInfo.psacmId],
                    };
                    let responseData = await this.$http.rushRedSuSettleAccount(data);
                    if (responseData.status == 200) {
                        this.$message({
                            message: responseData.message,
                            type: "success",
                        });
                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            if (this.getRequestData.cmName == '') this.getRequestData.cmId = ''
            let responseData = await this.$http.getSalesSettlementKeep(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }

            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.dpsmId]
                }
                let responseData = await this.$http.delPsSettlementApply(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },

        // 提交审核
        submitDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }

            this.$confirm('确定要提交审核?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.dpsmId]
                }
                let responseData = await this.$http.subPsSettlementApply(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()

        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
        this.ormId = sessionStorage.getItem('ormId')

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}

/* 上传图片 */
.upload_box {
    display: flex;
    align-items: center;
    justify-content: center;
}
.upload {
    width: 102px;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.upload li {
    position: relative;
    width: 102px;
    height: 102px;
    margin-right: 5px;
    margin-bottom: 5px;
    border: 1px solid #dedede;
}

.upload .active_li {
    border: none;
}

.image_label {
    display: block;
    width: 102px;
    height: 102px;
}

.upload li:last-child {
    border: none;
}

.upload li:last-child .image_label {
    border: 1px dashed #838383;
}

.upload li:last-child .image_label:hover {
    border: 1px dashed #409eff;
    cursor: pointer;
}

.upload li:last-child:hover .icon {
    color: #409eff;
}

.upload li .icon {
    color: #838383;
    font-size: 60px;
    margin: 20px 0 0 20px;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.upload li:hover .del {
    display: inline-block;
}

::v-deep .el-image__error {
    font-size: 7px;
}

::v-deep .cus-image {
    width: 100px !important;
    height: 100px !important;
}
::v-deep .img_box .cus-image {
    width: 30px !important;
    height: 30px !important;
}
::v-deep .cus-image img {
    width: 100px !important;
    height: 100px !important;
}
::v-deep .img_box .cus-image img {
    width: 30px !important;
    height: 30px !important;
}
</style>